import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard } from '@okta/okta-angular';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { B2cPaymentComponent } from 'projects/assessments/src/app/b2c-payment/b2c-payment.component';
import { AccountComponent } from './account/account.component';
import { AssessmentComponent } from './assessments/assessment/assessment.component';
import { CompleteComponent } from './assessments/complete/complete.component';
import { RespectComponent } from './assessments/respect/respect.component';
import { ViewAssessmentComponent } from './assessments/view-assessment/view-assessment.component';
import { AuthGuard } from './auth.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InviteComponent } from './invite/invite.component';
import { ProfileComponent } from './profile/profile.component';
import { RoleGuard } from './role.guard';
import { OktaLoginComponent } from './okta-login/okta-login.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'manage-account',
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [1, 2, 4] },
    children: [
      {
        path: '',
        component: AccountComponent,
      },
      {
        path: ':type',
        component: AccountComponent,
      }
    ]
  },
  {
    path: 'profile',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ProfileComponent,
      },
      {
        path: ':type',
        component: ProfileComponent,
      },
      {
        path: ':type/:person_id',
        component: ProfileComponent,
      }
    ]
  },
  {
    path: 'payment',
    canActivate: [AuthGuard],
    component: InviteComponent
  },
  {
    path: 'invite',
    children: [
      { path: '', component: InviteComponent, canActivate: [AuthGuard] },
      { path: ':token', component: RespectComponent },
    ],
  },
  {
    path: 'assessments',
    children: [
      {
        path: 'complete/:token',
        component: AssessmentComponent,
      },
      {
        path: 'complete',
        component: CompleteComponent,
      }
    ]
  },
  {
    path: 'respect',
    children: [
      {
        path: ':token',
        component: RespectComponent,
      }
    ]
  },
  {
    path: 'report',
    canActivate: [AuthGuard],
    children: [
      {
        path: ':report_id',
        component: ViewAssessmentComponent,
      }
    ]
  },
  {
    path: 'confirmation',
    component: B2cPaymentComponent,

  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent,
  },
  {
    path: 'okta',
    component: OktaLoginComponent,
    canActivate: [ OktaAuthGuard ],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
